import { without } from 'ramda'
import { Roles } from 'utils/consts/userRoles'
import { databaseFiltersName } from 'utils/consts'
import type { FiltersCollection } from '../filtersCollectionsRegistry'
import type { DatabaseFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import { pickEntries } from './entries'

type Role = string

const producersFullOrder = [
  databaseFiltersName.synonymsFilter,
  databaseFiltersName.countryFilter,
  databaseFiltersName.sourceFilter,
  databaseFiltersName.legalEntityFilter,
  databaseFiltersName.invalidRecordFilter,
  databaseFiltersName.hasWebsiteFilter,
  databaseFiltersName.hasEmailFilter,
  databaseFiltersName.hasPhoneFilter,
  databaseFiltersName.producerWWLFilter,
  databaseFiltersName.wineRegionEUFilter,
  databaseFiltersName.nationalGITypeFilter,
  databaseFiltersName.geoIndicationFilter,
  databaseFiltersName.specialClassificationFilter,
  databaseFiltersName.wineTypeFilter,
  databaseFiltersName.wineColourFilter,
  databaseFiltersName.sweetnessTypeFilter,
  databaseFiltersName.vintageFilter,
  databaseFiltersName.grapesFilter,
  databaseFiltersName.bottleSizeFilter,
  databaseFiltersName.packageTypeFilter,
  databaseFiltersName.alcoholLevelFilter,
  databaseFiltersName.certificatesFilter,
  databaseFiltersName.wwlRatingFilter,
  databaseFiltersName.usersFilter,
  databaseFiltersName.creationDateFilter,
  databaseFiltersName.lastUpdateFilter,
  databaseFiltersName.checkedByFilter,
]

export const getDatabaseProducersFiltersCollection = (
  role: Role
): FiltersCollection => {
  switch (role) {
    case Roles.PERSON:
      return pickEntries([
        databaseFiltersName.countryFilter,
        databaseFiltersName.wineRegionEUFilter,
        databaseFiltersName.nationalGITypeFilter,
        databaseFiltersName.geoIndicationFilter,
        databaseFiltersName.specialClassificationFilter,
        databaseFiltersName.wineTypeFilter,
        databaseFiltersName.wineColourFilter,
        databaseFiltersName.sweetnessTypeFilter,
        databaseFiltersName.vintageFilter,
        databaseFiltersName.grapesFilter,
        databaseFiltersName.alcoholLevelFilter,
        databaseFiltersName.certificatesFilter,
        databaseFiltersName.bottleSizeFilter,
        databaseFiltersName.packageTypeFilter,
        databaseFiltersName.hasVerifiedRepresentativeFilter,
        databaseFiltersName.wwlRatingFilter,
      ])
    case Roles.CONTENT:
    case Roles.SUPERADMIN:
      return pickEntries(producersFullOrder)
    case Roles.MANAGER:
      return pickEntries(
        without(
          [
            databaseFiltersName.sourceFilter,
            databaseFiltersName.checkedByFilter,
            databaseFiltersName.synonymsFilter,
          ],
          producersFullOrder
        )
      )
    default:
      return pickEntries([
        databaseFiltersName.usersFilter,
        databaseFiltersName.countryFilter,
        databaseFiltersName.creationDateFilter,
        databaseFiltersName.invalidRecordFilter,
      ])
  }
}

export const databaseProducersFiltersConfig: DatabaseFiltersConfig = {
  component: 'database',
  getFiltersCollection: getDatabaseProducersFiltersCollection,
  showResultsTextKey: 'filters.button.apply',
}
